/* eslint-disable import/prefer-default-export */
import { refreshTokenMutation } from '../graphql/mutations';

export const refreshBody = (refreshToken) => ({
  operationName: 'refreshToken',
  variables: { refreshToken },
  query: refreshTokenMutation,
});
